
import { get } from "..//common/query";

export const WX_PAY = data => get("/wxpay/productPCOrder", data);
export const ALI_PAY = data => get("/ali/productOrder", data);


